<template>
  <div class="submitLookingSite">
    <img src="/static/images/success.jpg" />
    <div class="m-t20 fs17" style="color: #0ca309">订单支付成功，请耐心等待场地方联系</div>

     <van-image
          height="300px"
          width="300px"
         src="/static/images/code.jpg"
          fit="cover"
        />

    <van-button plain color="#0ca309" size="small" @click="onsubmit()"
      >完成</van-button
    >
  </div>
</template>

<script>
import { Button , Image } from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Image.name]: Image,
  },
  data() {
    return {};
  },
  methods: {
    onsubmit() {
      this.$router.go(-2);
    },
  },
};
</script>

<style lang="less" scoped>
.submitLookingSite {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 50px 0px;
  font-size: 14px;

  .van-button {
    width: 150px;
    font-size: 14px;
    position: absolute;
    bottom: 50px;
    border-radius: 4px;
  }
}

</style>




// WEBPACK FOOTER //
// src/views/layout/home/playSuccess.vue